interface Props {}

function Page404(props: Props) {
    return (
        <div>404 Page not found</div>
    )
}

export default Page404